import { Locale } from './locales'

export interface ContactInfo {
  orderPhone?: string
  supportPhone?: string
  sizeHelperPhone?: string
  email: string
  url: string
}

export const CONTACT_INFO: Record<Locale, ContactInfo> = {
  [Locale.De]: {
    orderPhone: '09251 / 4646',
    supportPhone: '09251 / 4647',
    sizeHelperPhone: '09251 / 46172',
    email: 'info@goldner-fashion.com',
    url: '/c/service/kontaktformular/',
  },
  [Locale.At]: {
    orderPhone: '06229 / 2698-0',
    supportPhone: 'Fax 06229 / 2698-76',
    email: 'at-info@goldner-fashion.com',
    url: '/c/service/kontaktformular/',
  },
  [Locale.Ch]: {
    orderPhone: '052 304 84 84',
    sizeHelperPhone: '052 304 84 84',
    email: 'ch-info@goldner-fashion.com',
    url: '/c/service/kontaktformular/',
  },
  [Locale.FrCh]: {
    supportPhone: '052 304 84 04',
    email: 'ch-info@goldner-fashion.com',
    url: '/c/service/contact/',
  },
  [Locale.Fr]: {
    supportPhone: '03 88 69 24 69',
    email: 'info@goldner.fr',
    url: '/c/service/contact/',
  },
  [Locale.FrBe]: {
    supportPhone: '070 – 22 29 29',
    email: 'info@goldner.be',
    url: '/c/service/contact/',
  },
  [Locale.Nl]: {
    supportPhone: '030 - 65 92 500',
    email: 'info@goldner.nl',
    url: '/c/service/contact/',
  },
  [Locale.Be]: {
    supportPhone: '070 – 22 28 28',
    email: 'info@goldner.be',
    url: '/c/service/contact/',
  },
  [Locale.Fi]: {
    orderPhone: '(09) 42 458 937',
    supportPhone: '(09) 42 458 937',
    sizeHelperPhone: '(09) 42 458 937',
    email: 'info@goldner.fi',
    url: '/c/service/contact/',
  },
}
